import { Component, DoCheck, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild,AfterViewInit,OnDestroy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { cdkOverlayRef } from '../custom-overlay/cdk-overlay-ref';
import { CdkOverlyayService } from '../custom-overlay/cdk-overlyay.service';
import { TemplateRef } from '@angular/core';
import { NestedDropdownOverlayComponent } from './nested-dropdown-overlay/nested-dropdown-overlay.component';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-nested-dropdown',
  templateUrl: './nested-dropdown.component.html',
  styleUrls: ['./nested-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: NestedDropdownComponent
    }
  ]
})
export class NestedDropdownComponent implements OnInit,AfterViewInit,OnDestroy {
  /*
  ---------------@Input()  - except data field all other are optional
    data - data(array/object) from parent in which this overlay dropdown is used
    valueColumn - column name of actual value for the option //column name which have the value of the displayed list 
    displayColumn - column name of  display name of the option //column name which have to be displayed on the list 
    origin - origin of the dropdown
    style - style of the overlyay component sent from parent
    hasMultiSelect - true/false, this overlay has multi select option or not
    placeHolder - place holder in the overlay select text
  ----------------@Output() 
    SelectionChange - emit the selected 
  --------------variables used
    valueArray-array of actual values derived from @Input() data 
    displayArray-array of displayed values, only displayArray will be sent to dropdown overlay
    selectedItem-actual value of this custom - formControl
    displayItem-displayed value of this custom - formControl
    selectedList - actual value selected are sent as an array(only for multiselect) 
  */
  @Input() data;
  @Input() valueColumn;
  @Input() statusColumn;
  @Input() displayColumn;
  @Input() origin;
  @Input() style;
  @Input() hasMultiSelect: boolean;
  @Input() placeHolder;
  @Input() label?;
  @Input() isSearch: boolean = false;
  @Input() content:string
  @Input() header:string
  @Input() selectedIndex?:number
  @Output() SelectionChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() SelectionChangeWithIndex = new EventEmitter<{ value: any; index: number }>();

  @ViewChild('origin') dropdownOrigin: TemplateRef<any>;

  @Input() fontsize: string = '';
  @Input() overlaycontainer: string = '';
  @Input() readonly:boolean=false
  initialData:any
  overLayRef: cdkOverlayRef;

  valueArray;
  statusArray;
  displayArray;
  selectedItem;
  displayItem;
  selectedList;
  // @ViewChild('select') selectRef: ElementRef;
  index: number = 0;
  emittedData

  nestedIndex:number=0
  destroy$: Subject<boolean> = new Subject();

  //for controlValue Accessor
  onChange = (selectedItem: string) => { }; // this value will be sent to form
  onTouched = () => { };
  disabled: boolean = false;
  overlay_state: boolean = false;
  constructor(private _Service: CdkOverlyayService,
    private cdkoverlayDialog: CdkOverlyayService,) { }


  ngOnInit(): void {
    // console.log("--->",this.overLayRef)
    this.displayItem = "";
    this.initialData=this.data ? JSON.parse(JSON.stringify(this.data)) : {}
    // console.log("data>>>>>>>.",this.initialData,"disp>>>>>>>",this.displayArray)
  }

  ngAfterViewInit(){

    
   
    this.cdkoverlayDialog.$emittedValue.pipe(distinctUntilChanged(),takeUntil(this.destroy$)).subscribe(data=>{
      // console.log({data})
      if(data){
//console.log(this.overLayRef)
        if(this.overLayRef){
          this.emittedData=data.value
         
          this.overLayRef.close()
          // this.SelectionChange.emit(data.value)
          
          if (this.selectedIndex !== undefined) {
            this.SelectionChangeWithIndex.emit({
              value:data.value,
              index: data.index
            });
          }
        }
      }
    })
   
    
  }
 


  openOverlay(origin: any, component, componentInputs) {
    this.overLayRef = this.cdkoverlayDialog.open({
      data: [componentInputs,this.isSearch,this.header,this.selectedIndex],
    },
      origin, component)
    return this.overLayRef;
    
  }

  //to set config values and open the overlay dropdown component
  dropdownOverlay(origin) {

      let dropdownRef: cdkOverlayRef;
      dropdownRef=this.openOverlay(origin,NestedDropdownOverlayComponent,this.data)
      // this.overLayRef.$closed.pipe(takeUntil(this.destroy$)).subscribe(data=>{
      //   this.SelectionChange.emit(this.emittedData)
      // })
//console.log("Overlay-->",this.overLayRef)

      this.overLayRef.$cube.pipe(takeUntil(this.destroy$)).subscribe(data=>{
//console.log({data})
        this.SelectionChange.emit(data)
      })
    

  }
  fields(data:any){
    
    this.initialData=data
    this.nestedIndex =1
    setTimeout(() => {
      this.dropdownOverlay(this.dropdownOrigin)
    }, 0);
    
    

  }
  ngOnDestroy(){
    // this.overLayRef.close()
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
